module.exports = __webpack_public_path__ + "static/img/bb9c5fc.95a1d6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/rollImg/rollSale/bb9c5fc.jpg
// module id = Y4+p
// module chunks = 0